export default {"src":"/_next/static/media/GLOBE_PURPLE.8fc5eff8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};